@if (uiConfiguration?.hasAssignors) {
  <div>
    <h3>{{ 'common.labels.assignors' | transloco }}</h3>
    <!-- SecuredParties -->
    <div class="flex-container no-margin">
      <lib-parties-list
        partyTypeTitle="Assignor"
        [order]="order"
        [observableParties$]="parties$"
        [errors$]="observableErrors$"
        class="flex-item"
        [isEditable]="isEditable"
        [businessPartyType]="businessSecuredParty"
        [individualPartyType]="individualSecuredParty"
        [defaultPartyType]="businessSecuredParty"
        [uiConfiguration]="uiConfiguration!.assignorsConfiguration!"
        [expandedParty]="newParty"
        [reusableParties]="reusableSecuredParties"
        (partyAddedEvent)="handlePartyAddedEvent($event)"
        (reusablePartySavedEvent)="handleExistingPartySaveEvent($event)"
        (reusableLinkedPartiesSavedEvent)="handleExistingLinkedPartySaveEvent($event)"
        (partyUpdatedEvent)="handlePartySavedEvent($event)"
        (partyCopiedEvent)="handlePartyCopiedEvent($event)"
        (partyRemovedEvent)="handlePartyRemovedEvent($event)"
        (partyFormValueChangedEvent)="handlePartyFormValueChangedEvent($event)">
      </lib-parties-list>
    </div>
  </div>
}